export const GET_HOME_DASH_BW = 'GET_HOME_DASH_BW';
export const GET_HOME_DASH_BW_SUCCESS = 'GET_HOME_DASH_BW_SUCCESS';
export const GET_HOME_DASH_BW_FAIL = 'GET_HOME_DASH_BW_FAIL';
export const GET_HOME_DASH_BW_SUCCESS_MSG =
	'DATA_BANDWIDTH_RETRIEVED_SUCCESSFULLY';
export const NOT_DATA_AVAILABLE = 'NO_DATA_AVAILABLE'
export const GET_AP_DASH_BW = 'GET_AP_DASH_BW';
export const GET_AP_DASH_BW_SUCCESS = 'GET_AP_DASH_BW_SUCCESS';
export const GET_AP_DASH_BW_FAIL = 'GET_AP_DASH_BW_FAIL';
export const GET_AP_DASH_BW_SUCCESS_MSG =
	'DATA_BANDWIDTH_RETRIEVED_SUCCESSFULLY';

export const GET_GROUP_DASH_BW = 'GET_GROUP_DASH_BW';
export const GET_GROUP_DASH_BW_SUCCESS = 'GET_GROUP_DASH_BW_SUCCESS';
export const GET_GROUP_DASH_BW_FAIL = 'GET_GROUP_DASH_BW_FAIL';
export const GET_GROUP_DASH_BW_SUCCESS_MSG =
	'DATA_BANDWIDTH_RETRIEVED_SUCCESSFULLY';
